import React, { useState, forwardRef } from "react";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

// Password field with a show/hide toggle. Drop-in replacement for <Input type="password">.
export const PasswordInput = forwardRef(function PasswordInput({ className = "", ...props }, ref) {
  const { t } = useLang();
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input ref={ref} {...props} type={show ? "text" : "password"} className={`pr-11 ${className}`} />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        className="absolute inset-y-0 right-0 flex items-center pr-3 text-slate-400 hover:text-findo-indigo"
        data-testid="password-toggle"
        aria-label={show ? t("hc.hidePassword") : t("hc.showPassword")}
        tabIndex={-1}
      >
        {show ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
});
